import { useStyletron } from '@thanx/uikit/theme'

type DropdownPaginationButtonProps = {
  direction: 'left' | 'right'
  disabled: boolean
  onClick: () => void
  'aria-label': string
}

const DropdownPaginationButton = ({
  direction,
  disabled,
  onClick,
  'aria-label': ariaLabel,
}: DropdownPaginationButtonProps) => {
  const [css, defaultTheme] = useStyletron()

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={ariaLabel}
      className={css({
        marginLeft: direction === 'right' ? '4px' : '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        border: 'none',
        background: 'transparent',
        fontSize: '16px',
        color: disabled
          ? defaultTheme.colors.mono600
          : defaultTheme.colors.mono700,
        padding: '2px 6px',
        borderRadius: '4px',
        transition: 'background 0.2s',
        ':hover': {
          background: !disabled
            ? defaultTheme.colors.backgroundTertiary
            : undefined,
        },
      })}
      onClick={onClick}
    >
      <i
        className={`fa fa-chevron-${direction}`}
        style={{
          fontSize: defaultTheme.sizing.scale550 || '14px',
        }}
      ></i>
    </button>
  )
}

export default DropdownPaginationButton
